const cities = [
    'Helsinki',
    'Espoo',
    'Turku',
    'Tampere',
    'Rovaniemi',
    'Vantaa',
    'Oulu',
    'Lahti',
    'Kuopio',
    'Jyväskylä',
    'Pori',
    'Vaasa',
    'Lappeenranta',
    'Kotka',
    'Joensuu',
    'Hämeenlinna',
    'Seinäjoki',
    'Porvoo',
    'Mikkeli',
    'Kouvola',
    'Hyvinkää',
    'Järvenpää',
    'Nurmijärvi',
    'Rauma',
    'Kokkola',
    'Kajaani',
    'Kerava',
    'Lohja',
    'Savonlinna',
    'Loviisa',
    'Imatra',
    'Varkaus',
    'Riihimäki',
    'Valkeakoski',
    'Salo',
    'Forssa',
    'Kuusamo',
    'Iisalmi',
    'Hanko',
    'Pieksämäki',
    'Nokia',
    'Kemi',
    'Ylöjärvi',
    'Kaarina',
    'Savonranta',
    'Kangasala',
    'Alajärvi',
    'Uusikaupunki',
    'Heinola',
    'Jämsä',
    'Orimattila',
    'Haukipudas',
    'Lieto',
    'Kauniainen',
    'Äänekoski',
    'Kuortane',
    'Pieksänkoski',
    'Kuhmo',
    'Kitee',
    'Pudasjärvi',
    'Lempäälä',
    'Kurikka',
    'Kuusankoski',
    'Alavus',
    'Nivala',
    'Vammala',
    'Sipoo',
    'Kauhava',
    'Lapua',
    'Kankaanpää',
    'Karkkila',
    'Naantali',
    'Ähtäri',
    'Kemijärvi',
    'Virrat',
    'Kauhajoki',
    'Harjavalta',
    'Loimaa',
    'Siuntio',
    'Vimpeli',
    'Laukaa',
    'Kaarne',
    'Kinnula',
    'Liminka',
    'Viitasaari',
    'Hirvensalmi',
    'Huittinen',
    'Parainen',
    'Ylihärmä',
    'Pomarkku',
    'Pukkila',
    'Vihti',
    'Kivijärvi',
    'Kruunupyy',
    'Kolari',
    'Kankaanpää',
    'Kempele',
    'Alavus',
    'Närpiö',
    'Laihia',
    'Muhos',
    'Lapinjärvi',
    'Rovaniemi',
    'Ilmajoki',
    'Saarijärvi',
    'Liperi',
    'Äänekoski',
    'Pyhäjärvi',
    'Kokemäki',
    'Pälkäne',
    'Pyhäntä',
    'Loppi',
    'Tornio',
    'Parikkala',
    'Jalasjärvi',
    'Lieto',
    'Virolahti',
    'Mänttä',
    'Virrat',
    'Pielavesi',
    'Sodankylä',
    'Pudasjärvi',
    'Ylistaro',
    'Rusko',
    'Inkoo',
    'Kempele',
    'Perniö',
    'Laukaa',
    'Pihtipudas',
    'Ristiina',
    'Korpilahti',
    'Kontiolahti',
    'Jokioinen',
    'Närpiö',
    'Juupajoki',
    'Kiiminki',
    'Kurikka',
    'Rusko',
    'Saarijärvi',
    'Salla',
    'Siikainen',
    'Uusikaupunki',
    'Jyväskylä',
    'Kalajoki',
    'Kangasniemi',
    'Karvia',
    'Kitee',
    'Laitila',
    'Raahe',
    'Sauvo',
    'Savukoski',
    'Teuva',
    'Tuupovaara',
    'Uusikaupunki',
]

export default cities;